module.exports = __webpack_public_path__ + "img/image31.27c93f6f.webp";